import { Modal } from 'Shared/modal';

onDomReady(() => {
   $$('.patrolItems').addEvent('click:relay(.revisionActionBox a)', function (ev) {
      let a = $(this);
      let buttonGroup = this.parentNode;
      let itemCount = a.get('data-accept-count') || a.get('data-deny-count');
      let isDenyButton = a.hasClass('buttonDeny');
      ev.stop();

      // Disable buttons, so user doesn't double-submit.
      disableButtons(buttonGroup);

      if (
         itemCount > 1 &&
         !confirm(
            'This action will be applied to ' +
               itemCount +
               ' revisions.\n\nAre you sure you want to continue?'
         )
      ) {
         enableButtons(buttonGroup);
         return;
      }

      // For deny actions, show the denial reason modal
      if (isDenyButton) {
         let patrolItem = a.getParent('.patrolItems');
         let isTranslation = patrolItem && patrolItem.dataset.isTranslation === 'true';
         showDenialModal(a.get('href'), isTranslation, buttonGroup);
      } else {
         performAction(a.get('href'), a.get('edit-href'));
      }
   });

   $$('.js-toggle-selected').addEvent('click', function (ev) {
      let isSelected = this.hasClass('selected');
      $$('.js-toggle-target').removeClass('toggle-open');
      $$('.js-toggle-selected').removeClass('selected');

      let target = this.getParent().getElement('.js-toggle-target');
      target.toggleClass('toggle-open', !isSelected);
      this.toggleClass('selected', !isSelected);
   });

   function showDenialModal(denyUrl, isTranslation, buttonGroup) {
      let template = document.getElementById('denial-modal-template');
      if (!template) {
         // Fallback if modal template not found - just deny without reason
         performAction(denyUrl);
         return;
      }

      let modalContent = template.cloneNode(true);
      modalContent.id = '';
      modalContent.style.display = '';

      let editReasons = modalContent.querySelector('.edit-reasons');
      let translationReasons = modalContent.querySelector('.translation-reasons');
      if (isTranslation) {
         editReasons.style.display = 'none';
         translationReasons.style.display = '';
      }

      let submitBtn = modalContent.querySelector('.denial-submit-btn');
      let radioButtons = modalContent.querySelectorAll('input[name="denial_reason"]');
      let explanationTextarea = modalContent.querySelector('#denial-explanation');
      radioButtons.forEach(radio => {
         radio.addEventListener('change', () => {
            submitBtn.disabled = false;
            explanationTextarea.focus();
         });
      });

      let cancelBtn = modalContent.querySelector('.denial-cancel-btn');
      cancelBtn.addEventListener('click', () => {
         Modal.cancel();
      });

      submitBtn.addEventListener('click', () => {
         let selectedReason = modalContent.querySelector('input[name="denial_reason"]:checked');
         let explanation = modalContent.querySelector('#denial-explanation').value.trim();

         if (!selectedReason) {
            return;
         }

         let body = { reason: selectedReason.value };
         if (explanation) {
            body.explanation = explanation;
         }

         Modal.close();
         performAction(denyUrl, null, body);
      });

      Modal.open({
         type: 'element',
         element: modalContent,
         onCancel: () => {
            enableButtons(buttonGroup);
         },
      });
   }

   function performAction(href, editUrl, body = null) {
      new Request.API_2_0(href, { method: 'POST' })
         .send(body)
         .then(response => {
            if (editUrl) {
               window.location = editUrl;
            } else {
               window.location.reload();
            }
         })
         .catch(error => {
            alert(error);
         });
   }

   function disableButtons(buttonGroup) {
      buttonGroup.getChildren().forEach(el => {
         el.setAttribute('disabled', true);
      });
   }

   function enableButtons(buttonGroup) {
      buttonGroup.getChildren().forEach(el => {
         el.removeAttribute('disabled');
      });
   }
});
